module.exports = __webpack_public_path__ + "static/media/swebert_correa.582dffb7.jpg";